import { createSupabaseClient } from "../../../hooks/useSupabase";

// Walks any chain of merges server-side (see the migration) to the final live customer,
// returning null if customerId was never merged away.
const getCustomerMergeTarget = async (
  customerId: string,
): Promise<string | null> => {
  const supabaseClient = createSupabaseClient();

  const { data, error } = await supabaseClient.rpc(
    "get_customer_merge_target",
    {
      p_customer_id: customerId,
    },
  );

  if (error) throw new Error(error.message);

  return data ?? null;
};

export default getCustomerMergeTarget;
